module.exports = __webpack_public_path__ + "img/Loader-sm.984625f4.gif";